import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import PaymentDataForm from "./PaymentDataForm";
import PaymentDataForm1xbet from "./PaymentDataForm1xbet";

function PaymentDataFormIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? (
    <PaymentDataForm1xbet {...props} />
  ) : (
    <PaymentDataForm {...props} />
  );
}

export default PaymentDataFormIndex;
